import { useDispatch } from 'react-redux'
import { UseMutationResult } from '@tanstack/react-query'
import InfoWarning from 'assets/info-warning.svg'
import { CatalogueEntry } from 'models/catalogues'
import { ICFDISyncForm } from 'models/invoices.models'
import {
  selectCatalogue,
  selectInvoicesSync,
  selectProfile,
} from 'lib/helpers/selectors'
import { getYearList } from 'lib/helpers/utilities'
import { useAppSelector } from 'store/hooks'
import { resetSyncValues, setSyncFormValue } from 'actions/invoices'
import { IApiError } from 'services/Shared/shared.models'
import IOCustomForm from 'components/FormComponents/IOComponents/IOCustomForm/IOCustomForm'
import AutocompleteField from 'components/FormComponents/IOComponents/AutocompleteField/AutoCompleteField'
import SydDialog from '../SydDialog/SydDialog'
import SydExpandableInformationDetails from '../SydExpandableInformationDetails/SydExpandableInformationDetails'
import './styles.scss'

interface ISyncCFDIsDialogProps {
  open: boolean
  loading: boolean
  toggleSyncDialog: () => void
  syncCFDIS: UseMutationResult<void, IApiError, ICFDISyncForm, unknown>
}

const SyncCFDIsDialog = ({
  open,
  loading,
  toggleSyncDialog,
  syncCFDIS,
}: ISyncCFDIsDialogProps) => {
  const dispatch = useDispatch()

  const profile = useAppSelector(selectProfile)
  const months = useAppSelector(selectCatalogue('meses'))
  const years = getYearList(profile?.createdAt)
  // const tipoComprobantes = useAppSelector(selectCatalogue('tiposComprobantes'))
  const { endMonth, startMonth /*, type*/, year } =
    useAppSelector(selectInvoicesSync) || {}

  return (
    <SydDialog
      open={open}
      className="dialog-sync-invoices-component"
      title="Sincronizar con el SAT"
      subtitle="Para realizar la sincronización de CFDIs puedes configurar los siguientes datos:"
      primaryButtonText="Sincronizar"
      disablePrimaryButton={!endMonth || !startMonth || !year}
      loadingPrimaryButton={loading}
      secondaryButtonText="Cancelar"
      onCancel={() => {
        toggleSyncDialog()
        dispatch(resetSyncValues())
      }}
      form="syncForm"
      sideButtons>
      <SydExpandableInformationDetails
        className="sync-cfdis-dialog-info"
        title="Esta consulta podría tomar un tiempo"
        titleIcon={InfoWarning}
        content={
          <>
            <ul>
              <li>
                En algunos casos, una sincronización de una gran cantidad de
                CFDIs podría tardar hasta 72 horas en completarse.
              </li>
              <li>
                Mientras haya una sincronización en curso, no podrá realizarse
                una consulta idéntica al mismo tiempo.
              </li>
              <li>Te sugerimos realizar consultas precisas.</li>
            </ul>
          </>
        }
      />
      <IOCustomForm
        id="syncForm"
        onSubmit={async (form: ICFDISyncForm) => {
          syncCFDIS.mutate(form)
        }}>
        <AutocompleteField
          className="sync-input"
          name="year"
          label={'Año'}
          catalogue={years}
          value={year}
          onValue={(v: CatalogueEntry) => dispatch(setSyncFormValue('year', v))}
          getOptionSelected={(option: CatalogueEntry, value: CatalogueEntry) =>
            option.value === value.value
          }
          fullWidth
        />
        <AutocompleteField
          className="sync-input half"
          name="startMonth"
          label={'Mes inicio (desde)'}
          catalogue={months.slice(0, 12)}
          value={startMonth}
          onValue={(v: CatalogueEntry) =>
            dispatch(setSyncFormValue('startMonth', v))
          }
          getOptionSelected={(option: CatalogueEntry, value: CatalogueEntry) =>
            option.value === value.value
          }
          fullWidth
        />
        <AutocompleteField
          className="sync-input half"
          name="endMonth"
          label={'Mes final (hasta)'}
          catalogue={months.slice(0, 12)}
          value={endMonth}
          onValue={(v: CatalogueEntry) =>
            dispatch(setSyncFormValue('endMonth', v))
          }
          getOptionSelected={(option: CatalogueEntry, value: CatalogueEntry) =>
            option.value === value.value
          }
          fullWidth
        />
        {/* <AutocompleteField
      className="sync-input"
      name="type"
      label={'Ingreso/Egreso'}
      catalogue={_.filter(
        tipoComprobantes,
        c => ['I', 'E'].indexOf(c.value) > -1
      )}
      value={type}
      onValue={(v: CatalogueEntry) =>
        dispatch(setSyncFormValue('type', v))
      }
      getOptionLabel={(o: CatalogueEntry) => `${o.value} - ${o.label}`}
      renderOption={(o: CatalogueEntry) => (
        <span className="catalogue-option">{`${o.value} - ${o.label}`}</span>
      )}
      getOptionSelected={(
        option: CatalogueEntry,
        value: CatalogueEntry
      ) => option.idCatalogValues === value.idCatalogValues}
      fullWidth
    /> */}
      </IOCustomForm>
    </SydDialog>
  )
}

export default SyncCFDIsDialog
